/* Vario Racing – 50/50 two-tone rim option for the custom rim set.
   Adds "50/50 rim design?" + colour 2 front/rear below the Globo rim colours,
   writes them as line-item properties and adds the €50 add-on product to the cart. */
(function () {
  'use strict';
  var root = document.querySelector('[data-vr3d]');
  var FEE = root && root.getAttribute('data-fee');
  if (!FEE) return;
  var MAIN_TITLE = 'Vario Supermoto rim set – 100% CUSTOM';
  var box, form, hp = {}, colours, busy = false;

  function val(name) { var i = box && box.querySelector('input[name="' + name + '"]:checked'); return i ? i.value : ''; }

  function cloneSwatches(src, label, idp) {
    var c = src.cloneNode(true);
    c.removeAttribute('data-element-id');
    c.classList.add('vr5050__sw');
    var lc = c.querySelector('.label-content'); if (lc) lc.textContent = label;
    var sv = c.querySelector('.gpo-selected-values'); if (sv) sv.textContent = '';
    [].forEach.call(c.querySelectorAll('.messages'), function (m) { m.textContent = ''; });
    [].forEach.call(c.querySelectorAll('input'), function (i, k) {
      var l = i.id ? c.querySelector('label[for="' + i.id + '"]') : null;
      i.id = idp + '_' + k; if (l) l.setAttribute('for', i.id);
      i.name = idp; i.setAttribute('data-field-name', label);
      i.removeAttribute('data-name'); i.removeAttribute('data-type'); i.removeAttribute('presence');
      i.checked = false;
    });
    return c;
  }

  function build() {
    if (document.querySelector('.vr5050')) return true;
    var rear = document.querySelector('input[data-field-name="Rim ring color REAR"]');
    var src = rear && rear.closest('[data-element-id]');
    form = document.querySelector('form.product-form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    if (!src || !form) return false;

    box = document.createElement('div');
    box.className = 'vr5050';
    box.innerHTML =
      '<div class="gpo-element gpo-form__group gpo-col-12">' +
        '<label class="gpo-label"><span class="label-content">50/50 rim design?</span></label>' +
        '<div class="vr5050__seg" role="radiogroup">' +
          '<label><input type="radio" name="vr5050" data-field-name="50/50 rim design?" value="NO" checked><span>No – one colour</span></label>' +
          '<label><input type="radio" name="vr5050" data-field-name="50/50 rim design?" value="YES"><span>Yes – 50/50 <b>(+ €50,00)</b></span></label>' +
        '</div>' +
        '<p class="vr5050__hint">Each rim ring is split into two colour halves. Colour 1 is the rim ring colour above – pick colour 2 below.</p>' +
      '</div>';
    colours = document.createElement('div');
    colours.className = 'vr5050__cols';
    colours.hidden = true;
    colours.appendChild(cloneSwatches(src, 'Rim color 2 FRONT (50/50)', 'vr5050f'));
    colours.appendChild(cloneSwatches(src, 'Rim color 2 REAR (50/50)', 'vr5050r'));
    var err = document.createElement('p'); err.className = 'vr5050__err'; err.hidden = true;
    err.textContent = 'Please choose colour 2 for the front and rear rim (50/50 design).';
    colours.appendChild(err);
    box.appendChild(colours);
    src.parentNode.insertBefore(box, src.nextSibling);

    ['50/50 rim design', 'Rim color 2 FRONT', 'Rim color 2 REAR'].forEach(function (n) {
      var h = document.createElement('input'); h.type = 'hidden'; h.name = 'properties[' + n + ']'; h.disabled = true;
      form.appendChild(h); hp[n] = h;
    });
    box.addEventListener('change', sync);
    sync();
    return true;
  }

  function sync() {
    var on = val('vr5050') === 'YES';
    colours.hidden = !on;
    [].forEach.call(box.querySelectorAll('.vr5050__sw'), function (sw) {
      var i = sw.querySelector('input:checked'), s = sw.querySelector('.gpo-selected-values');
      if (s) s.textContent = i ? i.value : '';
    });
    hp['50/50 rim design'].disabled = !on; hp['50/50 rim design'].value = on ? 'Yes (+ €50)' : '';
    hp['Rim color 2 FRONT'].disabled = !on; hp['Rim color 2 FRONT'].value = val('vr5050f');
    hp['Rim color 2 REAR'].disabled = !on; hp['Rim color 2 REAR'].value = val('vr5050r');
    if (val('vr5050f') && val('vr5050r')) colours.querySelector('.vr5050__err').hidden = true;
  }

  // every visible required Globo field filled? (so the add-on is never added on its own)
  function globoComplete() {
    var ok = true;
    [].forEach.call(document.querySelectorAll('.gpo-element'), function (el) {
      if (!ok || box.contains(el) || el.offsetParent === null) return;
      if (!el.querySelector('.gpo-label.required')) return;
      var ins = el.querySelectorAll('input:not([type=hidden]), select, textarea');
      if (!ins.length) return;
      var filled = [].some.call(ins, function (i) {
        if (i.type === 'radio' || i.type === 'checkbox') return i.checked;
        return (i.value || '').trim() !== '';
      });
      if (!filled) ok = false;
    });
    return ok;
  }

  function handle(e, btn) {
    if (!box || val('vr5050') !== 'YES') return;
    if (form.getAttribute('data-vr5050-ok') === '1') return;
    if (!val('vr5050f') || !val('vr5050r')) {
      e.preventDefault(); e.stopImmediatePropagation();
      var er = colours.querySelector('.vr5050__err'); er.hidden = false;
      colours.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (!globoComplete()) return; // let Globo show its own "required" messages
    e.preventDefault(); e.stopImmediatePropagation();
    if (busy) return; busy = true;
    var q = parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +FEE, quantity: q, properties: { 'For': MAIN_TITLE, 'Rim color 2 FRONT': val('vr5050f'), 'Rim color 2 REAR': val('vr5050r') } }] })
    }).then(function (r) { if (!r.ok) throw new Error('add-on'); })
      .then(function () {
        form.setAttribute('data-vr5050-ok', '1');
        var b = btn || form.querySelector('[data-add-to-cart], [type="submit"]');
        if (b) b.click(); else if (form.requestSubmit) form.requestSubmit(); else form.submit();
        setTimeout(function () { form.removeAttribute('data-vr5050-ok'); }, 2000);
      })
      .catch(function () {
        var er = colours.querySelector('.vr5050__err'); er.textContent = 'Could not add the 50/50 option – please try again.'; er.hidden = false;
      })
      .then(function () { busy = false; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-add-to-cart], button[type="submit"], [name="add"]') : null;
    if (b && form && b.form === form) handle(e, b);
  }, true);
  document.addEventListener('submit', function (e) { if (form && e.target === form) handle(e, null); }, true);

  // Globo renders asynchronously – wait for it
  if (!build()) {
    var tries = 0, t = setInterval(function () { if (build() || ++tries > 60) clearInterval(t); }, 250);
  }
})();
